import { RouteRecordRaw } from "vue-router";
import Home from "../views/home/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: false,
    },
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   meta: {
  //     showBanner: true,
  //   },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
  {
    path: "/catalog",
    name: "Catalog",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/catalog/index.vue"),
  },
  {
    path: "/article",
    name: "Article",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    component: () =>
      import(/* webpackChunkName: "article" */ "../views/article/index.vue"),
  },
  {
    path: "/search",
    name: "Search",
    meta: {
      // bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/search/index.vue"),
  },
  {
    path: "/hof",
    name: "hof",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      // showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/hof/index.vue"),
  },
  {
    path: "/classes",
    name: "Classes",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/classes/index.vue"),
  },
  {
    path: "/construction",
    name: "construction",
    // meta: {
    //   bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
    //   showBanner: true,
    // },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/construction/index.vue"),
  },
];

export default routes;
